import { createFileRoute } from "@tanstack/react-router";
import { GuideRevisionPage } from "@/features/experiments/guide-revision-page";
import { uploadSearch } from "@/lib/upload-route";

export const Route = createFileRoute("/guides/$id")({
  validateSearch: uploadSearch,
  component: Page,
});
function Page() {
  const { id } = Route.useParams();
  return <GuideRevisionPage id={id} />;
}
